import api from "./api";

const applications = {
  getApplicationsList(query) {
    return api.get("/bids", { params: query});
  },
  createApplications(args) {
    return api.post(`/bids/`, args);
  },
  updateApplications(id, args) {
    return api.put(`/bids/${id}`, args);
  },
  getApplicationId(id) {
    return api.get(`/bids/${id}`,);
  },
  cancelApplications(id) {
    return api.post(`/bids/${id}/cancel`,);
  },
  closeApplications(id) {
    return api.post(`/bids/${id}/complete`,);
  },
  rejectApplications(id, body) {
    return api.post(`/bids/${id}/reject`, body);
  },
  approveApplications(id) {
    return api.post(`/bids/${id}/approve`,);
  },
  takeWorkApplications(id) {
    return api.post(`/bids/${id}/take-to-work`,);
  },

};

export default applications;
